export default __webpack_public_path__ + "static/media/Slide3.8bdbb9ab.png";